import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Spinner } from '../../components';
import { userActions } from '../../redux';

import './Error.scss';

const Logout: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userActions.logout());
  });

  return (
    <div className='center-content'>
      <Spinner size='large' />
    </div>
  );
};

export default Logout;
